import { PackageTypeWithTier, useUserPackages } from '../hooks/useUserPackages';
import { NoPackageAccessPage } from './no-access-modal';

interface PackageTierProtectedRouteProps {
  requiredPermissions: PackageTypeWithTier[];
  children: React.ReactNode;
}

export function PackageTierProtectedRoute({ requiredPermissions, children }: PackageTierProtectedRouteProps) {
  const { getPackageWithTier, isLoading } = useUserPackages();
  if (isLoading) return <></>;
  return requiredPermissions?.some((permission) => getPackageWithTier(permission)) ? (
    <>{children}</>
  ) : (
    <NoPackageAccessPage requiredPermissions={requiredPermissions} />
  );
}
